import { render } from "./SortTableDuplicationHistoricStatusCellComponent.vue?vue&type=template&id=1fa060d2"
import script from "./SortTableDuplicationHistoricStatusCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableDuplicationHistoricStatusCellComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__